<template>
  <header id="header" class="header fixed-top d-flex align-items-center">
    <div class="d-flex align-items-center justify-content-between">
      <router-link to="/" class="logo d-flex align-items-center d-none d-lg-block d-xl-block">
        <img :src="company === 2 ? 'assets/img/logo2.png' : 'assets/img/logo.png' " alt="Logo" class="d-none d-lg-block d-xl-block">
      </router-link>
    </div>
    <nav class="header-nav ms-auto">
      <ul class="d-flex align-items-center">

        <li class="nav-item dropdown pe-3">
          <a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
            <span class="d-none d-md-block dropdown-toggle ps-2">{{ user['mst_employee_name'] }}</span>
          </a>

          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
            <li class="dropdown-header">
              <h6>{{ user['mst_employee_name'] }}</h6>
              <span>{{ user['mst_division_name'] }} - {{ user['mst_employee_email'] }}</span>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>

            <div style="max-height: 200px; overflow-y: auto;">
              <li v-for="item in menu" :key="item.menu_id">
                <a class="dropdown-item d-flex align-items-center" :href="item.url" target="_blank">
                  <span>{{ item.menu_name }}</span>
                </a>
                <hr class="dropdown-divider">
              </li>
            </div>
            <li>
              <a class="dropdown-item d-flex align-items-center" href="#" @click="logout">
                <i class="bi bi-box-arrow-right"></i>
                <span>Logout</span>
              </a>
            </li>
          </ul>
        </li>

      </ul>
    </nav>

  </header>
</template>

<script>
import { EventBus } from '../eventBus';
export default {
  name: 'HeaderComponent',
  data() {
    return {
      userData: null,
      user: {},     // ✅
      menu: [],     // ✅
      company: null
    }
  },
  mounted() {
    const userData = localStorage.getItem('user_data');

    if (userData) {
      try {
        this.userData = JSON.parse(userData);
        this.user = this.userData.user;
        this.menu = this.userData.menu;
        localStorage.setItem('user', JSON.stringify(this.user));
      } catch (e) {
        console.error('Failed to parse user_data:', e);
      }
    } else {
      console.warn('No user data found in localStorage');
      const hostname = window.location.hostname;
      if (hostname === 'aces.loneless.xyz') {
        window.location.replace('https://ssov3.loneless.xyz');
      } else if (hostname === 'aces.fli.co.id') {
        window.location.replace('https://sso.fli.co.id');
      } else {
        window.location.replace('https://ssov3.loneless.xyz');
      }
    }
    this.company = localStorage.getItem('company');
    EventBus.$on("companyChanged", this.onCompanyChange);
  },
  methods: {
    logout() {
      localStorage.removeItem('user_data');
      localStorage.removeItem('user');
      localStorage.clear();
      sessionStorage.removeItem('token_jwt');
      const newWindow = window.open(
        'https://ssov3.loneless.xyz/logout/',
        'connectWindow',
        'width=1,height=1,toolbar=no,status=no,menubar=no,scrollbars=no,visible=none'
      );

      setTimeout(() => {
        window.location.replace('https://ssov3.loneless.xyz/signout');
        if (newWindow) newWindow.close();
      }, 1000);
    },
    onCompanyChange(newCompany) {
        this.company = newCompany;
    }
  }
};
</script>

